// Messages for operator/settings/Appearance (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.appearance.head': 'Appearance — Operator',
  'operator.appearance.title': 'Appearance',
  'operator.appearance.desc':
    'Choose the color scheme for the operator console. It applies to every operator; the customer portal always keeps the shared blue-gray.',
  'operator.appearance.active': 'In use',
  'operator.appearance.saved_toast': '{name} applied',
  'operator.appearance.scheme.current.name': 'Current (shared)',
  'operator.appearance.scheme.current.desc':
    'The shared blue-gray — identical to the customer portal.',
  'operator.appearance.scheme.steel.name': 'Steel-teal',
  'operator.appearance.scheme.steel.desc': 'Steel-teal accent with a teal-black sidebar.',
  'operator.appearance.scheme.indigo.name': 'Indigo-slate',
  'operator.appearance.scheme.indigo.desc': 'Indigo “admin console” look.',
  'operator.appearance.scheme.graphite.name': 'Graphite + red',
  'operator.appearance.scheme.graphite.desc': 'Graphite sidebar with a brand-red active trim.',
}

export const zhTW = {
  'operator.appearance.head': '外觀 — 操作員',
  'operator.appearance.title': '外觀',
  'operator.appearance.desc':
    '選擇操作員控制台的配色方案。此設定套用於所有操作員；客戶入口網站永遠維持共用的藍灰色。',
  'operator.appearance.active': '使用中',
  'operator.appearance.saved_toast': '已套用{name}',
  'operator.appearance.scheme.current.name': '目前（共用）',
  'operator.appearance.scheme.current.desc': '共用的藍灰色 — 與客戶入口網站相同。',
  'operator.appearance.scheme.steel.name': '鋼青',
  'operator.appearance.scheme.steel.desc': '鋼青色強調色，搭配青黑色側邊欄。',
  'operator.appearance.scheme.indigo.name': '靛藍',
  'operator.appearance.scheme.indigo.desc': '靛藍色「管理主控台」風格。',
  'operator.appearance.scheme.graphite.name': '石墨＋紅',
  'operator.appearance.scheme.graphite.desc': '石墨色側邊欄，搭配品牌紅色使用中標示。',
}
